import Fragment from './Fragment.js'

export default {
    fragment: Fragment,
}
